// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subHours as fn } from "../subHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subHoursWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subHoursWithOptions;
